import { useContext, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { MyContext } from '../../Context/MyProvider';
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import secureLocalStorage from 'react-secure-storage';
import Btn_loader from '../pages/Btn_loader';
import { Link, useNavigate } from 'react-router-dom';

const disposableDomains = new Set([
  "mailinator.com", "yopmail.com", "guerrillamail.com", "tempmail.com", "10minutemail.com",
  "sharklasers.com", "guerrillamailblock.com", "guerrillamail.net", "guerrillamail.org",
  "guerrillamail.biz", "grr.la", "getairmail.com", "trashmail.com", "trashmail.de",
  "trashmail.me", "temp-mail.org", "generator.email", "dispostable.com", "mailnesia.com",
  "maildrop.cc", "mintemail.com", "mytrashmail.com", "mailcatch.com", "33mail.com",
  "burnermail.io", "dropmail.me", "tempail.com", "fakeinbox.com", "discard.email",
  "mailnull.com", "moakt.com", "emei.ro", "temporary-address.com", "emailondeck.com",
  "getnada.com", "nada.ltd", "10minutemail.net", "10minutemail.co.uk", "boun.cr",
  "mailinator.net", "spamgourmet.com", "jetable.org", "temp-mail.ru", "tempmailo.com",
  "temp-mail.io", "tempmail.net", "inboxes.com", "tempmail.co", "mailticking.com",
  "fakemailgenerator.com", "temp-mail-generator.com", "check-mail.org", "mailforspam.com",
  "tempmailaddress.com", "mohmal.com", "mohmal.in", "guerrillamail.de", "guerrillamail.co"
]);

const isDisposableEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const parts = email.trim().toLowerCase().split('@');
  if (parts.length < 2) return false;
  const domain = parts[parts.length - 1];
  return disposableDomains.has(domain);
};

const features = [
  { icon: '🔮', title: 'Astrology Engine', desc: 'Precise Kundali, Kundali Match, Panchang & Transit APIs' },
  { icon: '🤖', title: 'AI Chat Assistant', desc: 'GPT-powered astrology answers in real time' },
  { icon: '⚡', title: 'Lightning Fast', desc: 'Sub-100ms API responses with 99.9% uptime' },
  { icon: '🔒', title: 'Secure & Private', desc: 'Enterprise-grade encryption on every request' },
];

const LoginPage = () => {
    const { BaseUrl, setIsLoginAuth, otpAutofill, googleLoginStatus,
            signupBonusStatus, signupBonusTokens,
            signupAiBonusStatus, signupAiBonusTokens, webLogo } = useContext(MyContext);
    const { enqueueSnackbar } = useSnackbar();

    const [email, setEmail] = useState("");
    const [otpFild, setOtpFild] = useState(Array(6).fill(''));
    const [otpSend, setOtpSend] = useState("");
    const [timer, setTimer] = useState(0);
    const [apiLoading, setApiLoading] = useState(false);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [activeFeature, setActiveFeature] = useState(0);

    const OtpRef = useRef(Array.from({ length: 6 }, () => null));
    const navigate = useNavigate();

    // Cycle feature highlights
    useEffect(() => {
        const iv = setInterval(() => setActiveFeature(i => (i + 1) % features.length), 3500);
        return () => clearInterval(iv);
    }, []);

    useEffect(() => {
        if (timer === 0) return;
        const TimeCount = setTimeout(() => setTimer(timer - 1), 1000);
        return () => clearTimeout(TimeCount);
    }, [timer]);

    const handleSubmit = () => {
        const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!email) { enqueueSnackbar('Please enter email !!', { variant: 'error' }); return; }
        if (!emailValidation.test(email)) { enqueueSnackbar('Please enter valid email !!', { variant: 'error' }); return; }
        if (isDisposableEmail(email)) { enqueueSnackbar('Temporary or disposable email addresses are not allowed.', { variant: 'error' }); return; }
        setApiLoading(true);
        handleSendOtp();
    };

    const hadnleOnChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;
        const Copy = [...otpFild];
        Copy[index] = value;
        setOtpFild(Copy);
        if (value && !isNaN(value) && index < OtpRef.current.length - 1) OtpRef.current[index + 1].focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) OtpRef.current[index - 1].focus();
    };

    const handleSendOtp = () => {
        axios.post(`${BaseUrl}/coustomer/validate/otp`, { email })
            .then((res) => {
                const ToastType = res.data.ResponseCode === 200 ? "success" : "error";
                enqueueSnackbar(res.data.message, { variant: ToastType });
                if (res.data.ResponseCode === 200) {
                    setOtpSend(res.data.otp);
                    setTimer(30);
                    setIsOtpSent(true);
                    if (otpAutofill !== 0 && res.data.otp) {
                        setOtpFild(res.data.otp.toString().split(""));
                    } else {
                        setOtpFild(Array(6).fill(''));
                    }
                }
                setApiLoading(false);
            })
            .catch(() => setApiLoading(false));
    };

    const handleMatchOtp = () => {
        const otpStr = otpFild.join("");
        if (otpAutofill === 0) { setApiLoading(true); handleSignUp({ email, otp: otpStr }); }
        else if (otpSend == otpStr) { setApiLoading(true); handleSignUp({ email, otp: otpStr }); }
        else enqueueSnackbar('OTP invalid !!', { variant: 'error' });
    };

    const handleSignUp = (data) => {
        axios.post(`${BaseUrl}/coustomer/validate/signup`, { 
            email: data.email, 
            name: data.name || "", 
            otp: data.otp || "",
            isGoogle: data.isGoogle || false,
            googleToken: data.googleToken || ""
        })
            .then((res) => {
                const ToastType = res.data.ResponseCode === 200 ? "success" : "error";
                enqueueSnackbar(res.data.message, { variant: ToastType });
                if (res.data.ResponseCode === 200) {
                    secureLocalStorage.setItem("Localdata", JSON.stringify(res.data.customer));
                    secureLocalStorage.setItem("IsAuth", false);
                    setIsLoginAuth(false);
                    navigate("/");
                }
                setApiLoading(false);
            })
            .catch(() => setApiLoading(false));
    };

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const userInfo = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                });
                handleSignUp({ 
                    email: userInfo.data.email, 
                    name: userInfo.data.name || '',
                    isGoogle: true,
                    googleToken: tokenResponse.access_token
                });
            } catch (err) {
                console.error('Google login error', err);
                enqueueSnackbar('Google login failed. Please try again.', { variant: 'error' });
            }
        },
        onError: () => enqueueSnackbar('Google login failed. Please try again.', { variant: 'error' }),
    });

    const handleKeyPress = (e) => { if (e.key === "Enter") handleSubmit(); };

    const hasBonus = signupBonusStatus === 1 || signupAiBonusStatus === 1;

    return (
        <div className='login_page' style={{ minHeight: '100vh', display: 'flex' }}>

            {/* ── Left: Form Panel ── */}
            <div className="flex-1 flex flex-col items-center justify-center p-6 lg:p-14 relative bg-white">

                {/* Close button */}
                <button
                    onClick={() => navigate("/")}
                    className='absolute top-5 right-6 p-2 rounded-full hover:bg-gray-100 transition-colors duration-200'
                    aria-label="Close"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>

                <div className="w-full max-w-md">

                    {/* Logo */}
                    <div className="mb-8">
                        <div className="inline-flex items-center gap-2 mb-6">
                            <img src={BaseUrl + webLogo} className="w-8 h-8 object-contain" alt="Logo" />
                            <span className="font-bold text-[16px] text-gray-800">AstroSphere API</span>
                        </div>

                        {!isOtpSent ? (
                            <>
                                <h1 className="text-[30px] font-black text-gray-900 leading-tight mb-1">
                                    Welcome back 👋
                                </h1>
                                <p className="text-gray-500 text-[15px]">Sign in or create your free account</p>
                            </>
                        ) : (
                            <>
                                <h1 className="text-[28px] font-black text-gray-900 leading-tight mb-1">
                                    Check your inbox 📬
                                </h1>
                                <p className="text-gray-500 text-[15px]">
                                    We sent a 6-digit code to <span className="font-semibold text-gray-700">{email}</span>
                                </p>
                            </>
                        )}
                    </div>

                    {/* Welcome Bonus pill (only if bonus is enabled) */}
                    {hasBonus && (
                        <div className="mb-6 flex flex-wrap gap-2">
                            {signupBonusStatus === 1 && (
                                <div className="flex items-center gap-1.5 bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-200 text-indigo-700 text-[12px] font-semibold px-3 py-1.5 rounded-full">
                                    <span>🎁</span>
                                    <span>{(signupBonusTokens || 0).toLocaleString()} free Module tokens on signup</span>
                                </div>
                            )}
                            {signupAiBonusStatus === 1 && (
                                <div className="flex items-center gap-1.5 bg-gradient-to-r from-pink-50 to-rose-50 border border-pink-200 text-pink-700 text-[12px] font-semibold px-3 py-1.5 rounded-full">
                                    <span>✨</span>
                                    <span>{(signupAiBonusTokens || 0).toLocaleString()} free AI tokens on signup</span>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Form */}
                    {!isOtpSent ? (
                        <div>
                            <div className="mb-5">
                                <label className="block text-[14px] font-semibold text-gray-700 mb-1.5">Email address</label>
                                <div className="relative">
                                    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                                        </svg>
                                    </div>
                                    <input
                                        type='email'
                                        placeholder="you@example.com"
                                        className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl text-[15px] outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all duration-200 bg-gray-50 focus:bg-white"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyDown={handleKeyPress}
                                    />
                                </div>
                            </div>

                            <button
                                disabled={apiLoading}
                                onClick={handleSubmit}
                                className="w-full h-[48px] rounded-xl font-bold text-[15px] text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed"
                                style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' }}
                            >
                                {apiLoading ? <Btn_loader CustomeStyle={"bg-white"} /> : "Continue →"}
                            </button>

                            {googleLoginStatus !== 0 && (
                                <>
                                    <div className="flex items-center gap-3 my-6">
                                        <div className="flex-1 h-px bg-gray-200" />
                                        <span className="text-[13px] text-gray-400 font-medium">or continue with</span>
                                        <div className="flex-1 h-px bg-gray-200" />
                                    </div>
                                    <button
                                        onClick={() => googleLogin()}
                                        className="w-full flex items-center justify-center gap-3 h-[48px] rounded-xl border border-gray-200 bg-white hover:bg-gray-50 hover:border-gray-300 hover:shadow-md transition-all duration-200 font-semibold text-[15px] text-gray-700"
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                                        </svg>
                                        Continue with Google
                                    </button>
                                </>
                            )}
                        </div>
                    ) : (
                        <div>
                            {/* OTP grid */}
                            <div className="flex items-center gap-2 justify-between mb-5">
                                {otpFild.map((value, index) => (
                                    <input
                                        key={index}
                                        type='text'
                                        maxLength="1"
                                        value={value}
                                        ref={(e) => OtpRef.current[index] = e}
                                        onChange={(e) => hadnleOnChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        className="w-0 min-w-0 flex-1 aspect-square rounded-xl border-2 border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none text-center font-black text-[20px] text-gray-800 transition-all duration-200 bg-gray-50 focus:bg-white"
                                    />
                                ))}
                            </div>

                            <div className="flex justify-between items-center mb-6">
                                <p className="text-[13px] text-gray-500">Didn't receive it?</p>
                                {timer > 0
                                    ? <span className="text-[13px] text-gray-500 font-medium">Resend in 00:{timer.toString().padStart(2, "0")}</span>
                                    : <button onClick={handleSendOtp} className="text-[13px] font-bold text-indigo-600 hover:text-indigo-700">Resend code</button>
                                }
                            </div>

                            <button
                                disabled={apiLoading}
                                onClick={handleMatchOtp}
                                className="w-full h-[48px] rounded-xl font-bold text-[15px] text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl disabled:opacity-70"
                                style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' }}
                            >
                                {apiLoading ? <Btn_loader CustomeStyle={"bg-white"} /> : "Verify & Sign In"}
                            </button>

                            <p onClick={() => { setOtpSend(""); setIsOtpSent(false); }}
                               className='w-full text-center text-[13px] mt-4 text-gray-400 hover:text-gray-700 cursor-pointer transition-colors'>
                                ← Back to login
                            </p>
                        </div>
                    )}

                    <p className="text-[12px] text-gray-400 text-center mt-8">
                        By continuing you agree to our <Link to="/page/terms-and-conditions" className="underline cursor-pointer hover:text-gray-600 transition-colors">Terms of Service</Link> &amp; <Link to="/page/privacy-policy" className="underline cursor-pointer hover:text-gray-600 transition-colors">Privacy Policy</Link>
                    </p>
                </div>
            </div>

            {/* ── Right: Branding Panel ── */}
            <div className="flex-1 relative hidden md:flex flex-col overflow-hidden"
                 style={{ background: 'linear-gradient(145deg, #0f0c29 0%, #302b63 45%, #24243e 100%)' }}>

                {/* Animated grid */}
                <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="lgrid" width="50" height="50" patternUnits="userSpaceOnUse">
                            <path d="M 50 0 L 0 0 0 50" fill="none" stroke="white" strokeWidth="0.8"/>
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#lgrid)" />
                </svg>

                {/* Glowing orbs */}
                <div className="absolute top-[-80px] right-[-80px] w-[350px] h-[350px] rounded-full opacity-20"
                     style={{ background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)' }} />
                <div className="absolute bottom-[-60px] left-[-60px] w-[280px] h-[280px] rounded-full opacity-15"
                     style={{ background: 'radial-gradient(circle, #db2777 0%, transparent 70%)' }} />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] rounded-full opacity-10"
                     style={{ background: 'radial-gradient(circle, #4f46e5 0%, transparent 70%)' }} />

                {/* Stars */}
                {[...Array(20)].map((_, i) => (
                    <div key={i}
                         className="absolute rounded-full bg-white"
                         style={{
                             width: `${1 + Math.random() * 2}px`,
                             height: `${1 + Math.random() * 2}px`,
                             top: `${Math.random() * 100}%`,
                             left: `${Math.random() * 100}%`,
                             opacity: 0.2 + Math.random() * 0.5,
                             animation: `twinkle ${2 + Math.random() * 3}s ease-in-out infinite alternate`,
                             animationDelay: `${Math.random() * 2}s`,
                         }}
                    />
                ))}

                {/* Main content */}
                <div className="relative z-10 flex flex-col h-full p-12 justify-between">

                    {/* Top brand */}
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <img src={BaseUrl + webLogo} className="w-9 h-9 object-contain" alt="Logo" />
                            <span className="font-bold text-white text-[17px]">AstroSphere API</span>
                        </div>
                        <p className="text-white/40 text-[13px]">The most powerful astrology API platform</p>
                    </div>

                    {/* Center: Animated feature card */}
                    <div className="flex-1 flex flex-col items-center justify-center">

                        {/* Big floating icon */}
                        <div className="text-[72px] mb-6"
                             style={{ animation: 'floatBig 4s ease-in-out infinite alternate', filter: 'drop-shadow(0 0 30px rgba(124,58,237,0.6))' }}>
                            {features[activeFeature].icon}
                        </div>

                        {/* Feature cards */}
                        <div className="w-full max-w-sm">
                            {features.map((f, i) => (
                                <div key={i}
                                     onClick={() => setActiveFeature(i)}
                                     className="flex items-start gap-3 p-3 rounded-xl mb-2 cursor-pointer transition-all duration-500"
                                     style={{
                                         background: activeFeature === i ? 'rgba(255,255,255,0.1)' : 'transparent',
                                         border: activeFeature === i ? '1px solid rgba(255,255,255,0.2)' : '1px solid transparent',
                                         backdropFilter: activeFeature === i ? 'blur(8px)' : 'none',
                                     }}>
                                    <span className="text-[22px] shrink-0">{f.icon}</span>
                                    <div>
                                        <p className="text-white font-bold text-[14px] leading-snug">{f.title}</p>
                                        <p className="text-white/50 text-[12px] leading-snug mt-0.5">{f.desc}</p>
                                    </div>
                                    {activeFeature === i && (
                                        <div className="ml-auto shrink-0 w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5" />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Bottom: Bonus callout */}
                    {hasBonus && (
                        <div className="rounded-2xl p-4 border border-white/10"
                             style={{ background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
                            <p className="text-white/60 text-[11px] uppercase tracking-wider font-semibold mb-2">🎁 New User Bonus</p>
                            <div className="flex flex-wrap gap-2">
                                {signupBonusStatus === 1 && (
                                    <span className="text-[12px] font-bold text-indigo-300 bg-indigo-500/20 border border-indigo-500/30 px-2.5 py-1 rounded-full">
                                        {(signupBonusTokens || 0).toLocaleString()} Module Tokens Free
                                    </span>
                                )}
                                {signupAiBonusStatus === 1 && (
                                    <span className="text-[12px] font-bold text-pink-300 bg-pink-500/20 border border-pink-500/30 px-2.5 py-1 rounded-full">
                                        {(signupAiBonusTokens || 0).toLocaleString()} AI Tokens Free
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <style>{`
                    @keyframes twinkle {
                        from { opacity: 0.1; transform: scale(0.8); }
                        to   { opacity: 0.8; transform: scale(1.3); }
                    }
                    @keyframes floatBig {
                        from { transform: translateY(0px) rotate(-3deg); }
                        to   { transform: translateY(-16px) rotate(3deg); }
                    }
                `}</style>
            </div>

        </div>
    );
};

export default LoginPage;